require("jquery-ui-bundle");



//////////////////
// WEBPACK FOOTER
// ./Scripts/site-jqui.js
// module id = 10
// module chunks = 2